<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Laporan Mengikut Kod Akaun">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_dari"
                            required
                            label="Dari"
                            type="date"
                        />
                        <z-lookup
                            label="Akaun"
                            :url="service_pembayaran + 'lookup/akaun_bayaran'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.akaun_id"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                        <z-lookup
                            label="Cawangan"
                            :url="service_pembayaran + 'lookup/jabatan_user'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                        />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <z-table
                ref="tbluser"
                title=""
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
            </z-table>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_pembayaran + "laporan/kod_akaun",
            reload: true,
            resit_id: null,
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/bayaran/laporan/kod_akaun" },
                { label: "Laporan", route: "/bayaran/laporan/kod_akaun" },
                {
                    label: "Laporan Kod Akaun",
                    route: "/bayaran/laporan/kod_akaun",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", akaun_id: "", jabatan_id: "" },
        };
    },
    methods: {
        search() {
            this.$inertia.visit(
                window.route("bayaran.laporan.kod_akaun") +
                    "?tarikh_dari=" +
                    this.cari.tarikh_dari +
                    "&tarikh_hingga=" +
                    this.cari.tarikh_hingga +
                    "&akaun_id=" +
                    this.cari.akaun_id+
                    "&jabatan_id=" +
                    this.cari.jabatan_id,
                { preserveScroll: true }
            );
        },
        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", akaun_id: "", jabatan_id: "" };
            this.search();
        },

        cetak() {
            window.location.href = this.service_pembayaran+'laporan/kod_akaun/cetak?user_id='+this.auth.user.id+
            "&tarikh_dari=" +
            this.cari.tarikh_dari +
            "&tarikh_hingga=" +
            this.cari.tarikh_hingga +
            "&akaun_id=" +
            this.cari.akaun_id+
            "&jabatan_id=" +
            this.cari.jabatan_id;
        },
    },
    watch: {},
    mounted() {
        // override default setting
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.akaun_id == "undefined") {
            this.cari.akaun_id = "";
        }
        if (this.cari.jabatan_id == "undefined") {
            this.cari.jabatan_id = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
